<div class="dialog-container">
    <h2 style="padding: 8px" mat-dialog-title>Logs</h2>

    <mat-dialog-content style="max-height: 600px">
        <mat-card *ngFor="let m of mensagens" class="message-card" [ngClass]="m.tipo.toLowerCase()">
            <mat-card-content style="display: flex;gap: 8px">
                <ng-container [ngSwitch]="m.tipo">
                    <mat-icon *ngSwitchCase="'SUCCESS'" style="color: green">check_circle</mat-icon>
                    <mat-icon *ngSwitchCase="'ERROR'" style="color: red">error</mat-icon>
                </ng-container>
                <span style="font-size: 14px">{{ m.mensagem }}</span>
            </mat-card-content>
        </mat-card>
    </mat-dialog-content>

    <mat-dialog-actions style="display: flex;justify-content: end;padding: 8px;margin-bottom: 0">
        <button mat-raised-button mat-dialog-close color="primary">Fechar</button>
    </mat-dialog-actions>
</div>
